export default __webpack_public_path__ + "static/media/free-lunch.de331d75.svg";